import React from 'react';
import ReactDOM from 'react-dom/client';
import './index.css';
import App from './App';
import reportWebVitals from './reportWebVitals';
import { BrowserRouter } from 'react-router-dom';
import { UserProvider } from './context/UserContext';
import { TaskProvider } from './context/TaskContext';
import { ContractorsProvider } from './context/ContractorsContext';
import { StatusProvider } from './context/StatusContext';
import { RolesProvider } from './context/RolesContext';
import { ArchiveProvider } from './context/ArchiveContext'
import { SocketProvider } from './context/SocketContext';
import { PriceProvider } from './context/PriceContext';
import { OrderProvider } from './context/OrderContext';

const root = ReactDOM.createRoot(document.getElementById('root'));
root.render(
  // <React.StrictMode>
    <BrowserRouter>
    <SocketProvider>
    <UserProvider>
      <RolesProvider>
      <ContractorsProvider>
        <PriceProvider>
          <OrderProvider>
            <StatusProvider>
              <TaskProvider>
                <ArchiveProvider>
                  <App />
                </ArchiveProvider>
              </TaskProvider>
            </StatusProvider>
        </OrderProvider>
        </PriceProvider>
      </ContractorsProvider>
      </RolesProvider>
    </UserProvider>
    </SocketProvider>
    </BrowserRouter>
  // </React.StrictMode>
);
if ('serviceWorker' in navigator) {
  window.addEventListener('load', () => {
    navigator.serviceWorker.register('/firebase-messaging-sw.js')
      .then(registration => {
        console.log('Service Worker зарегистрирован:', registration.scope);
      })
      .catch(error => {
        console.error('Регистрация Service Worker завершилась неудачей:', error);
      });
  });
}

// If you want to start measuring performance in your app, pass a function
// to log results (for example: reportWebVitals(console.log))
// or send to an analytics endpoint. Learn more: https://bit.ly/CRA-vitals
reportWebVitals();
